import React from 'react';
import CheckboxandRadio from '../../../Componant/Forms/FormControl/CheckRadio';

const CheckBoxAndRadioBtn = () => {
  return (
    <div className='page-body'>
      <CheckboxandRadio />
    </div>
  );
};

export default CheckBoxAndRadioBtn;
